import { config } from "./config/config";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './css/style.css';
import './lib/bootstrap/css/mvit-global.min.css';
import './lib/font-awesome/css/font-awesome.min.css';
import './lib/ionicons/css/ionicons.min.css';
import './lib/animate/animate.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { I18nextProvider } from "react-i18next";
import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import CustomLanguageDetector from "./utilities/CustomLanguageDetector";

//English
import enAuth from "./locales/en/auth.json";
import enCommon from "./locales/en/common.json";
//Hindi
import hiAuth from "./locales/hi/auth.json";
import hiCommon from "./locales/hi/common.json";

i18n.use(CustomLanguageDetector).init({
  resources: {
    en: {
      translation: { ...enAuth, ...enCommon },
    },
    hi: {
      translation: { ...hiAuth, ...hiCommon },
    },
  },
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
});




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* '/mvit/react-site' */}
    <BrowserRouter basename={config.env.basePath}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
